module.exports = __webpack_public_path__ + "assets/img/mecha-5121bf0c.png";